// /* eslint-disable react/prop-types */
// /* eslint-disable react/function-component-definition */
// /**
// =========================================================
// * Material Dashboard 2 React - v2.2.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/material-dashboard-react
// * Copyright 2023 Creative Tim (https://www.creative-tim.com)
//
// Coded by www.creative-tim.com
//
//  =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
// */
//
// // @mui material components
// import Icon from "@mui/material/Icon";
// import { Snackbar, Grid, Typography, Autocomplete, TextField } from "@mui/material";
// // Material Dashboard 2 React components
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
// import MDButton from "components/MDButton";
// import MDAvatar from "components/MDAvatar";
// import MDProgress from "components/MDProgress";
// import { useState, useEffect, useMemo, use, useRef } from "react";
// import { useMaterialUIController } from "context";
// import BASE_URL from "config/Base_URL";
// import axios from "axios";
// import MyModal from "components/Modal";
// import Swal from "sweetalert2";
// import MDTableCell from "@mui/material/TableCell";
// import MDTableRow from "@mui/material/TableRow";
// import MDTableBody from "@mui/material/TableBody";
// import MDTable from "@mui/material/Table";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import items from "ajv/lib/vocabularies/applicator/items";
//
// const data = ({ filterSales, setPenjualanParent, products = [] }) => {
//   const token = sessionStorage.getItem("token");
//   const [controller] = useMaterialUIController();
//   const { darkMode } = controller;
//   const [open, setOpen] = useState(false);
//   const [message, setMessage] = useState("");
//
//   const [modalDeleteShow, setModalDeleteShow] = useState(false);
//   const [modalDetailShow, setModalDetailShow] = useState(false);
//   const [modalPaymentShow, setModalPaymentShow] = useState(false);
//   const [modalUpdateSalesShow, setModalUpdateSalesShow] = useState(false);
//
//   const [penjualan, setPenjualan] = useState([]);
//
//   const [invoicePayment, setInvoicePayment] = useState("");
//   const [payment, setPayment] = useState("");
//   const [maxPayment, setMaxPayment] = useState(0);
//
//   const [invoice, setInvoice] = useState("");
//   const [username, setUsername] = useState("");
//   const [dateSales, setDateSales] = useState("");
//   const [deliveryDate, setDeliveryDate] = useState("");
//   const [deliveryStatus, setDeliveryStatus] = useState("");
//   const [shippingMethod, setShippingMethod] = useState("");
//   const [shippingAddress, setShippingAddress] = useState("");
//   const [totalPaymentSales, setTotalPaymentSales] = useState("");
//   const [paymentStatusSales, setPaymentStatusSales] = useState("");
//   const [priceSales, setPriceSales] = useState("");
//   const [noteSales, setNoteSales] = useState("");
//   const [itemSales, setItemSales] = useState([]);
//   const [noPembeli, setNoPembeli] = useState("");
//   const [address, setAddress] = useState("");
//
//   const [updateInvoiceNumber, setUpdateInvoiceNumber] = useState("");
//
//   // State form update (terpisah dari form detail agar tidak konflik)
//   const [updateBusinessName, setUpdateBusinessName] = useState("");
//   const [updateSelectedUser, setUpdateSelectedUser] = useState(null);
//   const [updateDateSales, setUpdateDateSales] = useState("");
//   const [updateDeliveryDate, setUpdateDeliveryDate] = useState("");
//   const [updateDeliveryStatusSales, setUpdateDeliveryStatusSales] = useState("");
//   const [updateTotalPayment, setUpdateTotalPayment] = useState("");
//   const [updateNote, setUpdateNote] = useState("");
//   const [updateSelectedProducts, setUpdateSelectedProducts] = useState([]);
//   const [updateSelectedProduct, setUpdateSelectedProduct] = useState(null);
//   const [updateCustomProduct, setUpdateCustomProduct] = useState({
//     name: "",
//     price: "",
//     unit: "",
//     quantity: 1,
//   });
//
//   const [selectedDate, setSelectedDate] = useState("");
//
//   const vertical = "top";
//   const horizontal = "right";
//
//   const handleClose = () => {
//     setOpen(false);
//   };
//
//   const snackbarComponentSales = (
//     <Snackbar
//       anchorOrigin={{ vertical, horizontal }}
//       open={open}
//       onClose={handleClose}
//       message={message}
//       key={vertical + horizontal}
//       autoHideDuration={4000}
//     />
//   );
//
//   const formatRupiah = (angka) => {
//     return new Intl.NumberFormat("id-ID", {
//       style: "currency",
//       currency: "IDR",
//       minimumFractionDigits: 0,
//     }).format(angka);
//   };
//
//   // ================================================================
//   //                            GET PENJUALAN
//   // ================================================================
//
//   const getTodayDate = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, "0");
//     const day = String(today.getDate()).padStart(2, "0");
//
//     return `${year}-${month}-${day}`;
//   };
//
//   const fetchPenjualan = async (dateValue) => {
//     const tanggal = dateValue || getTodayDate();
//
//     try {
//       const config = {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json", // tetap digunakan
//         },
//       };
//
//       const response = await axios.get(`${BASE_URL}/sales?date=${tanggal}`, config);
//
//       const responseData = response.data;
//       if (responseData && responseData.data) {
//         const dataArray = Array.isArray(responseData.data)
//           ? responseData.data
//           : [responseData.data];
//         setPenjualan(dataArray);
//         setPenjualanParent(dataArray);
//       } else {
//         setPenjualan([]);
//         setPenjualanParent(responseData.data);
//       }
//
//       setMessage("Berhasil mengambil data Penjualan");
//       setOpen(true);
//     } catch (error) {
//       console.error("Error:", error);
//       setMessage("Tidak ada data penjualan di bulan ini");
//       setOpen(true);
//     }
//   };
//
//   // ================================================================
//   //                            Update PENJUALAN
//   // ================================================================
//
//   // ================================================================
//   //                    FETCH DATA UNTUK EDIT SALES
//   // ================================================================
//   const renderFormUpdate = async (numberInvoice) => {
//     try {
//       const response = await axios.get(
//         `${BASE_URL}/get/sales/update?invoiceNumber=${numberInvoice}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//
//       const d = response.data.data;
//       setUpdateInvoiceNumber(numberInvoice);
//       setUpdateBusinessName(d.businessName);
//       setUpdateDateSales(d.date);
//       setUpdateDeliveryDate(d.deliveryDate);
//       setUpdateDeliveryStatusSales(d.deliveryStatus);
//       setUpdateTotalPayment(d.totalPayment?.toString() || "0");
//       setUpdateNote(d.note);
//
//       // Konversi items dari API ke format selectedProducts
//       // disabled:true → tidak ditampilkan sama sekali
//       const mappedItems = (d.items || [])
//         .filter((item) => !item.disabled)
//         .map((item) => ({
//           id: item.productId !== 0 ? item.productId : `custom-${item.itemId}`,
//           itemId: item.itemId, // simpan itemId asli untuk keperluan update API
//           productId: item.productId,
//           name: item.name,
//           price: item.price,
//           unit: item.unit,
//           quantity: item.amount,
//           subtotal: item.price * item.amount,
//           isExisting: true, // tandai bahwa ini produk dari server
//         }));
//
//       setUpdateSelectedProducts(mappedItems);
//       setModalUpdateSalesShow(true);
//     } catch (error) {
//       console.log(error);
//       Swal.fire("Gagal", "Gagal mengambil data penjualan", "error");
//     }
//   };
//
//   const statusOptions = ["SELESAI", "PENGIRIMAN", "GAGAL"];
//
//   const renderFormUpdateSales = (
//     <MDBox sx={{ width: "70vw" }}>
//       {/* Nama Restoran (readonly karena dari businessName) */}
//       <MDBox mb={2}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Nama Restoran Pembeli"
//           value={updateBusinessName}
//           InputLabelProps={{ shrink: true }}
//         />
//       </MDBox>
//
//       <MDBox mb={2}>
//         <MDInput
//           required
//           type="date"
//           label="Tanggal Penjualan"
//           fullWidth
//           value={updateDateSales}
//           onChange={(e) => setUpdateDateSales(e.target.value)}
//           InputLabelProps={{ shrink: true }}
//         />
//       </MDBox>
//
//       <MDBox mb={2}>
//         <MDInput
//           required
//           type="date"
//           label="Tanggal Pengantaran"
//           fullWidth
//           value={updateDeliveryDate}
//           onChange={(e) => setUpdateDeliveryDate(e.target.value)}
//           InputLabelProps={{ shrink: true }}
//         />
//       </MDBox>
//
//       <MDBox mb={2}>
//         <Autocomplete
//           disablePortal
//           options={statusOptions}
//           value={updateDeliveryStatus}
//           onChange={(_, newValue) => setUpdateDeliveryStatus(newValue)}
//           fullWidth
//           renderInput={(params) => <TextField {...params} label="Status Pengiriman" />}
//         />
//       </MDBox>
//
//       <MDBox mb={2}>
//         <MDInput
//           type="text"
//           label="Catatan"
//           fullWidth
//           value={updateNote}
//           onChange={(e) => setUpdateNote(e.target.value)}
//           multiline
//           inputProps={{ maxLength: 250 }}
//           rows={2}
//           sx={{
//             "& .MuiOutlinedInput-root": { alignItems: "flex-start" },
//             "& textarea": { resize: "vertical", minHeight: "80px" },
//           }}
//         />
//         <Typography variant="caption" color="textSecondary">
//           Maksimal 250 karakter • {updateNote.length}/250
//         </Typography>
//       </MDBox>
//
//       {/* Tambah produk dari daftar */}
//       <MDBox mb={2} style={{ display: "flex", gap: "2%" }}>
//         <Autocomplete
//           options={products}
//           getOptionLabel={(option) => `${option.name} - ${option.unit || ""}`}
//           value={updateSelectedProduct}
//           onChange={(_, newValue) => setUpdateSelectedProduct(newValue)}
//           sx={{ width: "90%" }}
//           renderInput={(params) => (
//             <TextField {...params} label="Pilih Produk" variant="outlined" />
//           )}
//         />
//         <MDButton
//           variant="gradient"
//           color="dark"
//           onClick={handleUpdateAddProduct}
//           disabled={!updateSelectedProduct}
//           sx={{ height: "52px" }}
//         >
//           <Icon sx={{ fontWeight: "bold" }}>add</Icon>
//         </MDButton>
//       </MDBox>
//
//       {/* Produk custom */}
//       <MDBox mb={2}>
//         <MDTypography variant="h6">Produk Lainnya (Jika tidak tersedia di daftar)</MDTypography>
//         <TextField
//           label="Nama Produk"
//           fullWidth
//           sx={{ mb: 1 }}
//           value={updateCustomProduct.name}
//           onChange={(e) =>
//             setUpdateCustomProduct({ ...updateCustomProduct, name: e.target.value.toUpperCase() })
//           }
//         />
//         <TextField
//           label="Harga Produk"
//           fullWidth
//           type="text"
//           sx={{ mb: 1 }}
//           value={formatRupiah(updateCustomProduct.price)}
//           onChange={(e) => {
//             const onlyNums = e.target.value.replace(/[^0-9]/g, "");
//             setUpdateCustomProduct({ ...updateCustomProduct, price: onlyNums });
//           }}
//         />
//         <TextField
//           label="Unit"
//           fullWidth
//           sx={{ mb: 1 }}
//           value={updateCustomProduct.unit}
//           onChange={(e) =>
//             setUpdateCustomProduct({ ...updateCustomProduct, unit: e.target.value.toUpperCase() })
//           }
//         />
//         <TextField
//           label="Jumlah"
//           type="text"
//           fullWidth
//           sx={{ mb: 1 }}
//           value={updateCustomProduct.quantity?.toString() ?? ""}
//           onChange={(e) => {
//             let value = e.target.value;
//             if (/^\d*[.,]?\d{0,2}$/.test(value) || value === "") {
//               value = value.replace(",", ".");
//               setUpdateCustomProduct({ ...updateCustomProduct, quantity: value });
//             }
//           }}
//           onBlur={(e) => {
//             let value = e.target.value.replace(",", ".");
//             let formatted = parseFloat(value);
//             if (isNaN(formatted)) formatted = 0;
//             formatted = parseFloat(formatted.toFixed(2));
//             setUpdateCustomProduct({ ...updateCustomProduct, quantity: formatted });
//           }}
//         />
//         <MDButton
//           variant="outlined"
//           color="info"
//           fullWidth
//           onClick={() => {
//             if (updateCustomProduct.name && updateCustomProduct.price) {
//               setUpdateSelectedProducts((prev) => [
//                 ...prev,
//                 {
//                   id: `custom-${Date.now()}`,
//                   itemId: null,
//                   productId: 0,
//                   name: updateCustomProduct.name,
//                   price: parseFloat(updateCustomProduct.price),
//                   unit: updateCustomProduct.unit,
//                   quantity: updateCustomProduct.quantity,
//                   subtotal: parseFloat(updateCustomProduct.price) * updateCustomProduct.quantity,
//                   isExisting: false,
//                 },
//               ]);
//               setUpdateCustomProduct({ name: "", price: "", unit: "", quantity: 1 });
//             } else {
//               Swal.fire("Perhatian", "Silakan lengkapi Nama dan Harga produk lainnya", "warning");
//             }
//           }}
//         >
//           <Icon>add</Icon>&nbsp;Tambah Produk Lainnya
//         </MDButton>
//       </MDBox>
//
//       {/* Tabel produk yang sudah ada */}
//       {updateSelectedProducts.length > 0 && (
//         <MDBox mt={4}>
//           <MDTypography variant="h6">Daftar Produk</MDTypography>
//           <MDTable>
//             <MDTableBody>
//               <MDTableRow>
//                 <MDTableCell sx={{ fontWeight: "bold", width: "25%" }}>Nama Produk</MDTableCell>
//                 <MDTableCell sx={{ fontWeight: "bold", textAlign: "right", width: "15%" }}>
//                   Harga Satuan
//                 </MDTableCell>
//                 <MDTableCell sx={{ fontWeight: "bold", textAlign: "center", width: "10%" }}>
//                   Unit
//                 </MDTableCell>
//                 <MDTableCell sx={{ fontWeight: "bold", textAlign: "center", width: "15%" }}>
//                   Jumlah
//                 </MDTableCell>
//                 <MDTableCell sx={{ fontWeight: "bold", textAlign: "right", width: "20%" }}>
//                   Subtotal
//                 </MDTableCell>
//                 <MDTableCell sx={{ fontWeight: "bold", textAlign: "center", width: "10%" }}>
//                   Aksi
//                 </MDTableCell>
//               </MDTableRow>
//
//               {updateSelectedProducts.map((product) => (
//                 <MDTableRow key={product.id}>
//                   <MDTableCell>{product.name}</MDTableCell>
//                   <MDTableCell sx={{ textAlign: "right" }}>
//                     Rp {product.price.toLocaleString()}
//                   </MDTableCell>
//                   <MDTableCell sx={{ textAlign: "center" }}>{product.unit}</MDTableCell>
//                   <MDTableCell sx={{ textAlign: "center" }}>
//                     <TextField
//                       type="text"
//                       fullWidth
//                       sx={{
//                         width: "100%",
//                         maxWidth: "80px",
//                         "& .MuiInputBase-root": { height: "40px" },
//                       }}
//                       inputProps={{ inputMode: "decimal", style: { textAlign: "center" } }}
//                       value={product.quantity?.toString() ?? ""}
//                       onChange={(e) => {
//                         let value = e.target.value;
//                         if (/^\d*[.,]?\d{0,2}$/.test(value) || value === "") {
//                           handleUpdateQuantityChange(product.id, value.replace(",", "."));
//                         }
//                       }}
//                       onBlur={(e) => {
//                         let value = e.target.value.replace(",", ".");
//                         let formatted = parseFloat(value);
//                         if (isNaN(formatted)) formatted = 0;
//                         formatted = parseFloat(formatted.toFixed(2));
//                         handleUpdateQuantityChange(product.id, formatted);
//                       }}
//                     />
//                   </MDTableCell>
//                   <MDTableCell sx={{ textAlign: "right" }}>
//                     Rp {product.subtotal.toLocaleString()}
//                   </MDTableCell>
//                   <MDTableCell sx={{ textAlign: "center" }}>
//                     {/* Tombol hapus → langsung hilang dari tampilan */}
//                     <MDButton
//                       color="error"
//                       onClick={() => handleUpdateRemoveProduct(product.id)}
//                       sx={{ minWidth: "40px", width: "40px", height: "40px", padding: 0 }}
//                     >
//                       <Icon sx={{ fontWeight: "bold" }}>remove</Icon>
//                     </MDButton>
//                   </MDTableCell>
//                 </MDTableRow>
//               ))}
//
//               <MDTableRow>
//                 <MDTableCell colSpan={4} sx={{ textAlign: "right", fontWeight: "bold" }}>
//                   Total:
//                 </MDTableCell>
//                 <MDTableCell sx={{ textAlign: "right", fontWeight: "bold" }}>
//                   Rp {calculateUpdateTotal().toLocaleString()}
//                 </MDTableCell>
//                 <MDTableCell />
//               </MDTableRow>
//             </MDTableBody>
//           </MDTable>
//         </MDBox>
//       )}
//
//       <MDBox mb={2} mt={2}>
//         <MDInput
//           type="text"
//           label="Total Pembayaran"
//           fullWidth
//           value={formatRupiah(updateTotalPayment)}
//           onChange={(e) => {
//             const onlyNums = e.target.value.replace(/[^0-9]/g, "");
//             setUpdateTotalPayment(onlyNums);
//           }}
//         />
//       </MDBox>
//     </MDBox>
//   );
//
//   // ================================================================
//   //               HELPER FUNCTIONS UNTUK FORM UPDATE
//   // ================================================================
//   const handleUpdateQuantityChange = (id, newQuantity) => {
//     setUpdateSelectedProducts((prev) =>
//       prev.map((p) =>
//         p.id === id ? { ...p, quantity: newQuantity, subtotal: p.price * newQuantity } : p
//       )
//     );
//   };
//
//   const handleUpdateRemoveProduct = (id) => {
//     // Langsung hilang dari tampilan
//     setUpdateSelectedProducts((prev) => prev.filter((p) => p.id !== id));
//   };
//
//   // Perubahan jumlah kuantitas
//   const handleQuantityChange = (id, newQuantity) => {
//     const updatedProducts = selectedProducts.map((product) => {
//       if (product.id === id) {
//         return {
//           ...product,
//           quantity: newQuantity,
//           subtotal: product.price * newQuantity,
//         };
//       }
//       return product;
//     });
//     setSelectedProducts(updatedProducts);
//   };
//
//   const handleUpdateAddProduct = () => {
//     if (updateSelectedProduct) {
//       const existing = updateSelectedProducts.findIndex((p) => p.id === updateSelectedProduct.id);
//       if (existing >= 0) {
//         setUpdateSelectedProducts((prev) =>
//           prev.map((p, i) =>
//             i === existing
//               ? { ...p, quantity: p.quantity + 1, subtotal: p.price * (p.quantity + 1) }
//               : p
//           )
//         );
//       } else {
//         setUpdateSelectedProducts((prev) => [
//           ...prev,
//           {
//             id: updateSelectedProduct.id,
//             itemId: null,
//             productId: updateSelectedProduct.id,
//             name: `${updateSelectedProduct.name.toUpperCase()} - ${
//               updateSelectedProduct.unit?.toUpperCase() || "KG"
//             }`,
//             price: updateSelectedProduct.price,
//             unit: updateSelectedProduct.unit?.toUpperCase() || "KG",
//             quantity: 1,
//             subtotal: updateSelectedProduct.price,
//             isExisting: false,
//           },
//         ]);
//       }
//       setUpdateSelectedProduct(null);
//     }
//   };
//
//   const calculateUpdateTotal = () => updateSelectedProducts.reduce((sum, p) => sum + p.subtotal, 0);
//
//   // ================================================================
//   //                    SUBMIT UPDATE SALES
//   // ================================================================
//   const handleUpdateSales = async () => {
//     try {
//       const salesItems = updateSelectedProducts.map((p) => ({
//         itemId: p.itemId || 0,
//         productId: p.productId || 0,
//         name: p.name,
//         price: p.price,
//         unit: p.unit,
//         amount: parseFloat(p.quantity) || 0,
//       }));
//
//       const requestBody = {
//         businessName: updateBusinessName,
//         date: updateDateSales,
//         deliveryDate: updateDeliveryDate,
//         deliveryStatus: updateDeliveryStatus,
//         totalPayment: parseFloat(updateTotalPayment) || 0,
//         note: updateNote || "-",
//         items: salesItems,
//       };
//
//       // await axios.put(
//       //   // `${BASE_URL}/sales/update?invoiceNumber=${updateInvoiceNumber}`,
//       //   requestBody,
//       //   { headers: { Authorization: `Bearer ${token}` } }
//       // );
//
//       setModalUpdateSalesShow(false);
//       Swal.fire("Berhasil", "Penjualan berhasil diperbarui", "success");
//       fetchPenjualan();
//     } catch (error) {
//       setModalUpdateSalesShow(false);
//       console.log(error);
//       Swal.fire("Gagal", "Penjualan gagal diperbarui", "error");
//     }
//   };
//
//   // ================================================================
//   //                            DELETE PENJUALAN
//   // ================================================================
//
//   const handleDelete = async () => {
//     try {
//       const response = await axios.delete(`${BASE_URL}/sales/delete?id=${invoice}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       setModalDeleteShow(false);
//       Swal.fire("Berhasil", "Penjualan berhasil dihapus", "success");
//       fetchPenjualan();
//     } catch (error) {
//       setModalDeleteShow(false);
//       console.log(error);
//       Swal.fire("Gagal", "Penjualan gagal dihapus", "error");
//     }
//   };
//
//   // ================================================================
//   //                            DOWNLOAD NOTA
//   // ================================================================
//
//   const getDataNota = async (invoice) => {
//     try {
//       const response = await axios.get(`${BASE_URL}/nota/sales?id=${invoice}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       });
//
//       setNoPembeli(response.data.data.noHp);
//       setAddress(response.data.data.address);
//       // console.log(response.data.data);
//       // console.log(noPembeli);
//       // console.log(address);
//     } catch (error) {
//       console.log(error);
//     }
//   };
//
//   // yang digunakan untuk pembuatan nota pada sales
//   const downloadNota = () => {
//     const tinggiPerBaris = 6;
//     const tinggiHeader = 25;
//     const jarakSetelahTabel = 4;
//     const tinggiTotalSection = 21;
//     const tinggiTandaTangan = 20;
//     const tinggiFooter = 40;
//     const marginBawah = 10;
//
//     const tinggiTabel = itemSales.length * tinggiPerBaris;
//     const tinggiKertas =
//       tinggiHeader +
//       tinggiTabel +
//       jarakSetelahTabel +
//       tinggiTotalSection +
//       tinggiTandaTangan +
//       tinggiFooter +
//       marginBawah;
//
//     const doc = new jsPDF({
//       orientation: "landscape",
//       unit: "mm",
//       format: [297, tinggiKertas],
//     });
//
//     // Header
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(14);
//     doc.text("WENMART", 190, 20, { align: "center" });
//     doc.text("NOTA PEMBELIAN BARANG", 190, 30, { align: "center" });
//
//     // Info transaksi
//     doc.setFontSize(11);
//     const marginAtas = 6;
//     let y = 10 + marginAtas;
//     doc.text(`No. Invoice: ${invoice}`, 10, y);
//     y += 6;
//     doc.text(`Tanggal: ${dateSales}`, 10, y);
//     y += 6;
//     doc.text(`Tanggal Pengiriman: ${deliveryDate}`, 10, y);
//     y += 6;
//     doc.text(`Nama Restoran Pembeli: ${username}`, 10, y);
//     y += 6;
//     doc.text(`Nomor Handphone: ${noPembeli}`, 10, y);
//     y += 6;
//     doc.text(`Alamat: ${address}`, 10, y);
//
//     // Garis pemisah
//     doc.setLineWidth(0.2);
//     doc.line(10, y + 4, 287, y + 4);
//
//     // Tabel produk
//     const startYTabel = y + 15;
//     const tableWidth = 277;
//     const tableHeight = tinggiTabel + 15;
//
//     doc.rect(10, startYTabel, tableWidth, tableHeight);
//
//     doc.setFontSize(11);
//     doc.setFont("helvetica", "bold");
//
//     const headerColumns = [
//       { x: 10, width: 10, text: "No", align: "center" },
//       { x: 20, width: 120, text: "Nama Produk", align: "left" },
//       { x: 140, width: 20, text: "Qty", align: "center" },
//       { x: 160, width: 20, text: "Unit", align: "center" },
//       { x: 180, width: 40, text: "Harga", align: "right" },
//       { x: 220, width: 67, text: "Subtotal", align: "right" },
//     ];
//
//     headerColumns.forEach((col) => {
//       doc.text(col.text, col.x + col.width / 2, startYTabel + 4, { align: col.align });
//     });
//
//     // Isi tabel
//     doc.setFont("helvetica", "normal");
//     itemSales.forEach((item, index) => {
//       const rowY = startYTabel + 4 + (index + 1) * tinggiPerBaris;
//
//       doc.text((index + 1).toString(), 15, rowY, { align: "center" });
//       doc.text(item.name, 22, rowY, { maxWidth: 115, align: "left" });
//       doc.text(item.amount.toString(), 150, rowY, { align: "center" });
//       doc.text(item.unit, 170, rowY, { align: "center" });
//       doc.text(formatRupiah(item.price).replace("Rp", "").trim(), 200, rowY, { align: "right" });
//       doc.text(formatRupiah(item.total).replace("Rp", "").trim(), 285, rowY, { align: "right" });
//     });
//
//     // Total dan tanda tangan
//     let finalY = startYTabel + tableHeight + jarakSetelahTabel + 10;
//
//     doc.setFontSize(11);
//     doc.text("PENJUAL", 17, finalY);
//     doc.text("Pembeli / Penerima Barang", 46, finalY);
//     doc.text("Dicetak Oleh", 103, finalY);
//
//     doc.setFontSize(14);
//     doc.setFont("helvetica", "medium");
//     doc.text("Total Pembelian:", 180, finalY);
//     doc.text(formatRupiah(priceSales), 285, finalY, { align: "right" });
//
//     finalY += 7;
//     doc.text("Total Pembayaran:", 180, finalY);
//     doc.text(formatRupiah(totalPaymentSales), 285, finalY, { align: "right" });
//
//     finalY += 7;
//     doc.text("Status:", 180, finalY);
//     doc.text(paymentStatusSales, 285, finalY, { align: "right" });
//
//     // Kotak tanda tangan
//     doc.setLineWidth(0.1);
//     doc.rect(10, finalY - 18, 35, 20);
//     doc.rect(45, finalY - 18, 55, 20);
//     doc.rect(100, finalY - 18, 30, 20);
//
//     // Kotak total
//     doc.rect(175, finalY - 18, 112, 6);
//     doc.rect(175, finalY - 12, 112, 6);
//     doc.rect(175, finalY - 6, 112, 8);
//
//     // Footer
//     const footerY = tinggiKertas - marginBawah + 8;
//     doc.setDrawColor(0);
//     doc.setLineWidth(0.2);
//     doc.line(30, footerY - 10, 267, footerY - 10);
//
//     doc.setFontSize(8);
//     doc.setTextColor(80);
//     doc.setFont("helvetica", "normal");
//     doc.text("Terima kasih telah berbelanja di toko kami", 148.5, footerY - 4, { align: "center" });
//     doc.text("Hubungi: 0812-3456-7890 | IG: @tjiangfuwen", 148.5, footerY, { align: "center" });
//
//     doc.save(`nota_${invoice}.pdf`);
//   };
//
//   // const downloadNota = () => {
//   //   // --- PENGATURAN UKURAN & SPASI (SUDAH DIPERBESAR) ---
//   //   const tinggiPerBaris = 8.5; // Diperbesar agar baris font 11 tidak berdempetan
//   //   const tinggiHeader = 50;
//   //   const jarakSetelahTabel = 8;
//   //   const tinggiTotalSection = 30; // Diperbesar untuk mengakomodasi font total yang lebih besar
//   //   const tinggiTandaTangan = 30;
//   //   const tinggiFooter = 30;
//   //   const marginBawah = 10;
//   //
//   //   const tinggiTabel = itemSales.length * tinggiPerBaris + 16;
//   //   const tinggiKertas =
//   //     tinggiHeader +
//   //     tinggiTabel +
//   //     jarakSetelahTabel +
//   //     tinggiTotalSection +
//   //     tinggiTandaTangan +
//   //     tinggiFooter +
//   //     marginBawah;
//   //
//   //   const doc = new jsPDF({
//   //     orientation: "landscape",
//   //     unit: "mm",
//   //     format: [297, Math.max(tinggiKertas, 148)],
//   //   });
//   //
//   //   // --- HEADER: NAMA TOKO & JUDUL ---
//   //   doc.setFont("helvetica", "bold");
//   //   doc.setFontSize(26); // Diperbesar (sebelumnya 22)
//   //   doc.text("WENMART", 210, 20, { align: "center" });
//   //
//   //   doc.setFontSize(14); // Diperbesar (sebelumnya 12)
//   //   doc.text("NOTA PEMBELIAN BARANG", 210, 29, { align: "center" });
//   //
//   //   // --- HEADER: INFO TRANSAKSI ---
//   //   doc.setFont("helvetica", "bold");
//   //   doc.setFontSize(11); // Diperbesar (sebelumnya 10)
//   //   const marginAtas = 15;
//   //   const startXInfo = 15;
//   //   let yInfo = marginAtas;
//   //   const lineSpacing = 6.5; // Jarak antar baris diperlebar
//   //
//   //   doc.text(`No. Invoice`, startXInfo, yInfo);
//   //   doc.text(`: ${invoice}`, startXInfo + 42, yInfo);
//   //   yInfo += lineSpacing;
//   //   doc.text(`Tanggal`, startXInfo, yInfo);
//   //   doc.text(`: ${dateSales}`, startXInfo + 42, yInfo);
//   //   yInfo += lineSpacing;
//   //   doc.text(`Tanggal Pengiriman`, startXInfo, yInfo);
//   //   doc.text(`: ${deliveryDate}`, startXInfo + 42, yInfo);
//   //   yInfo += lineSpacing;
//   //   doc.text(`Nama Restoran`, startXInfo, yInfo);
//   //   doc.text(`: ${username}`, startXInfo + 42, yInfo);
//   //   yInfo += lineSpacing;
//   //   doc.text(`Nomor Handphone`, startXInfo, yInfo);
//   //   doc.text(`: ${noPembeli}`, startXInfo + 42, yInfo);
//   //   yInfo += lineSpacing;
//   //   doc.text(`Alamat`, startXInfo, yInfo);
//   //   doc.text(`: ${address}`, startXInfo + 42, yInfo);
//   //
//   //   const startYTabel = yInfo + 10;
//   //   doc.setLineWidth(0.3);
//   //   doc.line(15, startYTabel - 4, 282, startYTabel - 4);
//   //
//   //   // --- TABEL PRODUK ---
//   //   const tableWidth = 267;
//   //   doc.setLineWidth(0.1);
//   //   doc.rect(15, startYTabel, tableWidth, tinggiTabel);
//   //
//   //   const columns = [
//   //     { header: "No", x: 22, align: "center" },
//   //     { header: "Nama Produk", x: 35, align: "left" },
//   //     { header: "Qty", x: 155, align: "center" },
//   //     { header: "Unit", x: 175, align: "center" },
//   //     { header: "Harga", x: 230, align: "right" },
//   //     { header: "Subtotal", x: 275, align: "right" },
//   //   ];
//   //
//   //   doc.setFontSize(11); // Font header tabel diperbesar
//   //   doc.setFont("helvetica", "bold");
//   //   columns.forEach((col) => {
//   //     doc.text(col.header, col.x, startYTabel + 6.5, { align: col.align });
//   //   });
//   //
//   //   doc.line(15, startYTabel + 10, 282, startYTabel + 10);
//   //
//   //   doc.setFont("helvetica", "normal");
//   //   itemSales.forEach((item, index) => {
//   //     const rowY = startYTabel + 17 + index * tinggiPerBaris;
//   //
//   //     doc.text((index + 1).toString(), columns[0].x, rowY, { align: columns[0].align });
//   //     doc.text(item.name, columns[1].x, rowY, { maxWidth: 110, align: columns[1].align });
//   //     doc.text(item.amount.toString(), columns[2].x, rowY, { align: columns[2].align });
//   //     doc.text(item.unit, columns[3].x, rowY, { align: columns[3].align });
//   //     doc.text(formatRupiah(item.price).replace("Rp", "").trim(), columns[4].x, rowY, {
//   //       align: columns[4].align,
//   //     });
//   //     doc.text(formatRupiah(item.total).replace("Rp", "").trim(), columns[5].x, rowY, {
//   //       align: columns[5].align,
//   //     });
//   //   });
//   //
//   //   // --- BAGIAN TOTAL & TANDA TANGAN ---
//   //   let finalY = startYTabel + tinggiTabel + jarakSetelahTabel;
//   //   finalY += 12;
//   //
//   //   doc.setFontSize(11); // Font label tanda tangan
//   //   doc.setFont("helvetica", "normal");
//   //   doc.text("PENJUAL", 32, finalY, { align: "center" });
//   //   doc.text("Pembeli / Penerima Barang", 82, finalY, { align: "center" });
//   //   doc.text("Dicetak Oleh", 132, finalY, { align: "center" });
//   //
//   //   // Kotak Tanda Tangan (dipertinggi agar sejajar dengan kotak total yang baru)
//   //   doc.setLineWidth(0.1);
//   //   doc.rect(15, finalY - 6, 35, 27);
//   //   doc.rect(50, finalY - 6, 65, 27);
//   //   doc.rect(115, finalY - 6, 35, 27);
//   //
//   //   // Area Total Pembayaran
//   //   const xTotalLabel = 180;
//   //   const xTotalValue = 277;
//   //
//   //   // Kotak Total (Tinggi diperbesar dari 7/8 menjadi 9/10 agar muat font besar)
//   //   doc.rect(175, finalY - 6, 107, 9);
//   //   doc.rect(175, finalY + 3, 107, 9);
//   //   doc.rect(175, finalY + 12, 107, 9);
//   //
//   //   // FONT TOTAL DIPERBESAR MENJADI 12
//   //   doc.setFontSize(12);
//   //   doc.setFont("helvetica", "normal");
//   //   doc.text("Total Pembelian:", xTotalLabel, finalY + 0.5);
//   //   doc.text(formatRupiah(priceSales), xTotalValue, finalY + 0.5, { align: "right" });
//   //
//   //   // Jarak Y (vertikal) ditambah dari +7 menjadi +9 menyesuaikan tinggi kotak baru
//   //   doc.text("Total Pembayaran:", xTotalLabel, finalY + 9.5);
//   //   doc.text(formatRupiah(totalPaymentSales), xTotalValue, finalY + 9.5, { align: "right" });
//   //
//   //   doc.setFont("helvetica", "bold");
//   //   doc.text("Status:", xTotalLabel, finalY + 18.5);
//   //   doc.text(paymentStatusSales, xTotalValue, finalY + 18.5, { align: "right" });
//   //
//   //   // --- FOOTER ---
//   //   finalY += 35;
//   //   doc.setDrawColor(0);
//   //   doc.setLineWidth(0.3);
//   //   doc.line(40, finalY - 6, 257, finalY - 6);
//   //
//   //   doc.setFontSize(10); // Diperbesar (sebelumnya 9)
//   //   doc.setTextColor(100);
//   //   doc.setFont("helvetica", "italic");
//   //   doc.text("Terima kasih telah berbelanja di toko kami", 148.5, finalY, { align: "center" });
//   //   doc.setFont("helvetica", "normal");
//   //   doc.text("Hubungi: 0812-3456-7890 | IG: @tjiangfuwen", 148.5, finalY + 5.5, {
//   //     align: "center",
//   //   });
//   //
//   //   // --- SAVE PDF ---
//   //   doc.save(`nota_${invoice}.pdf`);
//   // };
//
//   // const downloadNota = () => {
//   //   // --- PENGATURAN UKURAN & SPASI (DIPERBESAR MAKSIMAL) ---
//   //   const tinggiPerBaris = 10.5; // Diperbesar dari 8.5 agar teks ukuran 13 tidak berdempetan
//   //   const tinggiHeader = 55;
//   //   const jarakSetelahTabel = 4;
//   //   const tinggiTotalSection = 38; // Ditambah untuk font 15
//   //   const tinggiTandaTangan = 38;
//   //   const tinggiFooter = 40;
//   //   const marginBawah = 10;
//   //   // const tinggiPerBaris = 6;
//   //   // const tinggiHeader = 25;
//   //   // const jarakSetelahTabel = 4;
//   //   // const tinggiTotalSection = 21;
//   //   // const tinggiTandaTangan = 20;
//   //   // const tinggiFooter = 40;
//   //   // const marginBawah = 10;
//   //
//   //   const tinggiTabel = itemSales.length * tinggiPerBaris + 18; // Ditambah spasi header tabel
//   //   const tinggiKertas =
//   //     tinggiHeader +
//   //     tinggiTabel +
//   //     jarakSetelahTabel +
//   //     tinggiTotalSection +
//   //     tinggiTandaTangan +
//   //     tinggiFooter +
//   //     marginBawah;
//   //
//   //   const doc = new jsPDF({
//   //     orientation: "landscape",
//   //     unit: "mm",
//   //     format: [297, Math.max(tinggiKertas, 148)],
//   //   });
//   //
//   //   // --- HEADER: NAMA TOKO & JUDUL ---
//   //   doc.setFont("helvetica", "bold");
//   //   doc.setFontSize(32); // Diperbesar ekstra
//   //   doc.text("WENMART", 210, 22, { align: "center" });
//   //
//   //   doc.setFontSize(18); // Subjudul diperbesar
//   //   doc.text("NOTA PEMBELIAN BARANG", 210, 32, { align: "center" });
//   //
//   //   // --- HEADER: INFO TRANSAKSI ---
//   //   doc.setFont("helvetica", "bold");
//   //   doc.setFontSize(13); // Diperbesar dari 11
//   //   const marginAtas = 16;
//   //   const startXInfo = 15;
//   //   let yInfo = marginAtas;
//   //   const lineSpacing = 7.5; // Spasi baris diperlebar dari 6.5
//   //   const indentTitikDua = 50; // Jarak horizontal ke titik dua digeser dari 42 ke 50
//   //
//   //   doc.text(`No. Invoice`, startXInfo, yInfo);
//   //   doc.text(`: ${invoice}`, startXInfo + indentTitikDua, yInfo);
//   //   yInfo += lineSpacing;
//   //   doc.text(`Tanggal`, startXInfo, yInfo);
//   //   doc.text(`: ${dateSales}`, startXInfo + indentTitikDua, yInfo);
//   //   yInfo += lineSpacing;
//   //   doc.text(`Tanggal Pengiriman`, startXInfo, yInfo);
//   //   doc.text(`: ${deliveryDate}`, startXInfo + indentTitikDua, yInfo);
//   //   yInfo += lineSpacing;
//   //   doc.text(`Nama Restoran`, startXInfo, yInfo);
//   //   doc.text(`: ${username}`, startXInfo + indentTitikDua, yInfo);
//   //   yInfo += lineSpacing;
//   //   doc.text(`Nomor Handphone`, startXInfo, yInfo);
//   //   doc.text(`: ${noPembeli}`, startXInfo + indentTitikDua, yInfo);
//   //   yInfo += lineSpacing;
//   //   doc.text(`Alamat`, startXInfo, yInfo);
//   //   doc.text(`: ${address}`, startXInfo + indentTitikDua, yInfo);
//   //
//   //   const startYTabel = yInfo + 12;
//   //   doc.setLineWidth(0.3);
//   //   doc.line(15, startYTabel - 4, 282, startYTabel - 4);
//   //
//   //   // --- TABEL PRODUK ---
//   //   const tableWidth = 267;
//   //   doc.setLineWidth(0.1);
//   //   doc.rect(15, startYTabel, tableWidth, tinggiTabel);
//   //
//   //   const columns = [
//   //     { header: "No", x: 22, align: "center" },
//   //     { header: "Nama Produk", x: 35, align: "left" },
//   //     { header: "Qty", x: 155, align: "center" },
//   //     { header: "Unit", x: 175, align: "center" },
//   //     { header: "Harga", x: 230, align: "right" },
//   //     { header: "Subtotal", x: 275, align: "right" },
//   //   ];
//   //
//   //   doc.setFontSize(13); // Ukuran tabel diperbesar dari 11
//   //   doc.setFont("helvetica", "bold");
//   //   columns.forEach((col) => {
//   //     doc.text(col.header, col.x, startYTabel + 7.5, { align: col.align });
//   //   });
//   //
//   //   doc.line(15, startYTabel + 11, 282, startYTabel + 11); // Garis header turun sedikit
//   //
//   //   doc.setFont("helvetica", "normal");
//   //   itemSales.forEach((item, index) => {
//   //     const rowY = startYTabel + 19 + index * tinggiPerBaris;
//   //
//   //     doc.text((index + 1).toString(), columns[0].x, rowY, { align: columns[0].align });
//   //     doc.text(item.name, columns[1].x, rowY, { maxWidth: 110, align: columns[1].align });
//   //     doc.text(item.amount.toString(), columns[2].x, rowY, { align: columns[2].align });
//   //     doc.text(item.unit, columns[3].x, rowY, { align: columns[3].align });
//   //     doc.text(formatRupiah(item.price).replace("Rp", "").trim(), columns[4].x, rowY, {
//   //       align: columns[4].align,
//   //     });
//   //     doc.text(formatRupiah(item.total).replace("Rp", "").trim(), columns[5].x, rowY, {
//   //       align: columns[5].align,
//   //     });
//   //   });
//   //
//   //   // --- BAGIAN TOTAL & TANDA TANGAN ---
//   //   let finalY = startYTabel + tinggiTabel + jarakSetelahTabel;
//   //   finalY += 14;
//   //
//   //   doc.setFontSize(12); // Teks label tanda tangan diperbesar dari 11
//   //   doc.setFont("helvetica", "normal");
//   //   doc.text("PENJUAL", 32, finalY, { align: "center" });
//   //   doc.text("Pembeli / Penerima Barang", 82, finalY, { align: "center" });
//   //   doc.text("Dicetak Oleh", 132, finalY, { align: "center" });
//   //
//   //   // Kotak Tanda Tangan (dipertinggi dari 27 menjadi 32)
//   //   doc.setLineWidth(0.1);
//   //   doc.rect(15, finalY - 7, 35, 32);
//   //   doc.rect(50, finalY - 7, 65, 32);
//   //   doc.rect(115, finalY - 7, 35, 32);
//   //
//   //   // Area Total Pembayaran
//   //   const xTotalLabel = 178; // Digeser sedikit agar tidak mentok ke kiri kotak
//   //   const xTotalValue = 277;
//   //
//   //   // Kotak Total (Tinggi diperbesar dari 9 menjadi 11 agar muat font besar)
//   //   const boxTotalHeight = 11;
//   //   doc.rect(175, finalY - 7, 107, boxTotalHeight);
//   //   doc.rect(175, finalY - 7 + boxTotalHeight, 107, boxTotalHeight);
//   //   doc.rect(175, finalY - 7 + boxTotalHeight * 2, 107, boxTotalHeight + 1);
//   //
//   //   // FONT TOTAL DIPERBESAR MENJADI 15
//   //   doc.setFontSize(15);
//   //   doc.setFont("helvetica", "normal");
//   //   doc.text("Total Pembelian:", xTotalLabel, finalY + 0.5);
//   //   doc.text(formatRupiah(priceSales), xTotalValue, finalY + 0.5, { align: "right" });
//   //
//   //   doc.text("Total Pembayaran:", xTotalLabel, finalY + 11.5); // Y digeser menyesuaikan kotak
//   //   doc.text(formatRupiah(totalPaymentSales), xTotalValue, finalY + 11.5, { align: "right" });
//   //
//   //   doc.setFont("helvetica", "bold");
//   //   doc.text("Status:", xTotalLabel, finalY + 22.5); // Y digeser menyesuaikan kotak
//   //   doc.text(paymentStatusSales, xTotalValue, finalY + 22.5, { align: "right" });
//   //
//   //   // --- FOOTER ---
//   //   finalY += 45;
//   //   doc.setDrawColor(0);
//   //   doc.setLineWidth(0.3);
//   //   doc.line(40, finalY - 6, 257, finalY - 6);
//   //
//   //   doc.setFontSize(11); // Diperbesar dari 10
//   //   doc.setTextColor(100);
//   //   doc.setFont("helvetica", "italic");
//   //   doc.text("Terima kasih telah berbelanja di toko kami", 148.5, finalY, { align: "center" });
//   //   doc.setFont("helvetica", "normal");
//   //   doc.text("Hubungi: 0812-3456-7890 | IG: @tjiangfuwen", 148.5, finalY + 6, {
//   //     align: "center",
//   //   });
//   //
//   //   // --- SAVE PDF ---
//   //   doc.save(`nota_${invoice}.pdf`);
//   // };
//
//   // ================================================================
//   //                                DETAIL SALES
//   // ================================================================
//
//   const handleDetailSales = async (idSales) => {
//     try {
//       const response = await axios.get(`${BASE_URL}/sales/detail?id=${idSales}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//
//       const penjualanResponse = response.data.data;
//       setInvoice(penjualanResponse.invoiceNumber);
//       setUsername(penjualanResponse.businessName);
//       setDateSales(penjualanResponse.date);
//       setDeliveryDate(penjualanResponse.deliveryDate);
//       setDeliveryStatus(penjualanResponse.deliveryStatus);
//       setShippingAddress(penjualanResponse.shippingAddress);
//       setShippingMethod(penjualanResponse.shippingMethod);
//       setTotalPaymentSales(penjualanResponse.payment);
//       setPriceSales(penjualanResponse.totalPrice);
//       setPaymentStatusSales(penjualanResponse.paymentStatus);
//       setNoteSales(penjualanResponse.note);
//       setItemSales(penjualanResponse.items);
//
//       setModalDetailShow(true);
//     } catch (error) {
//       console.log(error);
//       Swal.fire("Gagal", "Gagal menampilkan detail penjualan!", "error");
//     }
//   };
//
//   const renderFormDetailSales = (
//     <Grid container spacing={2}>
//       {/* Invoice Number & Nama Usaha */}
//       <Grid item xs={12} sm={6}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Invoice Number"
//           variant="outlined"
//           value={invoice}
//           InputLabelProps={{ shrink: true }}
//         />
//       </Grid>
//       <Grid item xs={12} sm={6}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Nama Restoran Pembeli"
//           variant="outlined"
//           value={username}
//           InputLabelProps={{ shrink: true }}
//         />
//       </Grid>
//
//       {/* Tanggal Penjualan & Pengiriman */}
//       <Grid item xs={12} sm={6}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Tanggal Penjualan"
//           variant="outlined"
//           value={dateSales}
//           InputLabelProps={{ shrink: true }}
//         />
//       </Grid>
//       <Grid item xs={12} sm={6}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Tanggal Pengiriman"
//           variant="outlined"
//           value={deliveryDate}
//           InputLabelProps={{ shrink: true }}
//         />
//       </Grid>
//
//       {/* Status Pengiriman & Total Penjualan */}
//       <Grid item xs={12} sm={6}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Status Pengiriman"
//           variant="outlined"
//           value={deliveryStatus}
//           InputLabelProps={{ shrink: true }}
//         />
//       </Grid>
//       <Grid item xs={12} sm={6}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Total Penjualan"
//           variant="outlined"
//           value={formatRupiah(priceSales)}
//           InputLabelProps={{ shrink: true }}
//         />
//       </Grid>
//
//       {/* Total Pembayaran & Status */}
//       <Grid item xs={12} sm={6}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Total Pembayaran"
//           variant="outlined"
//           value={formatRupiah(totalPaymentSales)}
//           InputLabelProps={{ shrink: true }}
//         />
//       </Grid>
//       <Grid item xs={12} sm={6}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Status"
//           variant="outlined"
//           value={paymentStatusSales}
//           InputLabelProps={{ shrink: true }}
//         />
//       </Grid>
//
//       {/* metode pengiriman */}
//       <Grid item xs={12} sm={12}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Metode Pengiriman"
//           variant="outlined"
//           value={shippingMethod}
//           InputLabelProps={{ shrink: true }}
//         />
//       </Grid>
//
//       {/* Alamat Pengiriman */}
//       <Grid item xs={12}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Alamat Pengiriman"
//           variant="outlined"
//           value={shippingAddress}
//           InputLabelProps={{ shrink: true }}
//           multiline
//           rows={2}
//           sx={{
//             "& .MuiOutlinedInput-root": { alignItems: "flex-start" },
//             "& textarea": {
//               resize: "vertical",
//               minHeight: "50px",
//             },
//           }}
//         />
//       </Grid>
//
//       {/* Catatan */}
//       <Grid item xs={12}>
//         <MDInput
//           fullWidth
//           disabled
//           label="Catatan"
//           variant="outlined"
//           value={noteSales}
//           InputLabelProps={{ shrink: true }}
//           multiline
//           rows={2}
//           sx={{
//             "& .MuiOutlinedInput-root": { alignItems: "flex-start" },
//             "& textarea": {
//               resize: "vertical",
//               minHeight: "80px",
//             },
//           }}
//         />
//         <Typography variant="caption" color="textSecondary">
//           Maksimal 250 karakter • {noteSales.length}/250
//         </Typography>
//       </Grid>
//
//       {/* Tabel Penjualan */}
//       <Grid item xs={12}>
//         <MDTable>
//           <MDTableBody>
//             <MDTableRow>
//               <MDTableCell sx={{ fontWeight: "bold" }}>Nama Produk</MDTableCell>
//               <MDTableCell sx={{ fontWeight: "bold", textAlign: "right" }}>
//                 Harga Satuan
//               </MDTableCell>
//               <MDTableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Unit</MDTableCell>
//               <MDTableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Jumlah</MDTableCell>
//               <MDTableCell sx={{ fontWeight: "bold", textAlign: "right" }}>Subtotal</MDTableCell>
//             </MDTableRow>
//             {itemSales.map((product) => (
//               <MDTableRow key={product.id}>
//                 <MDTableCell>{product.name}</MDTableCell>
//                 <MDTableCell sx={{ textAlign: "right" }}>{formatRupiah(product.price)}</MDTableCell>
//                 <MDTableCell sx={{ textAlign: "center" }}>{product.unit}</MDTableCell>
//                 <MDTableCell sx={{ textAlign: "center" }}>{product.amount}</MDTableCell>
//                 <MDTableCell sx={{ textAlign: "right" }}>{formatRupiah(product.total)}</MDTableCell>
//               </MDTableRow>
//             ))}
//             <MDTableRow>
//               <MDTableCell colSpan={4} sx={{ textAlign: "right", fontWeight: "bold" }}>
//                 Total:
//               </MDTableCell>
//               <MDTableCell sx={{ textAlign: "right", fontWeight: "bold" }}>
//                 {formatRupiah(priceSales)}
//               </MDTableCell>
//             </MDTableRow>
//           </MDTableBody>
//         </MDTable>
//       </Grid>
//
//       {/* Tombol Download */}
//       <Grid item xs={12}>
//         <MDBox display="flex" justifyContent="flex-end">
//           <MDButton
//             variant="gradient"
//             color="info"
//             onClick={() => {
//               getDataNota(invoice);
//               downloadNota();
//             }}
//           >
//             <Icon>download</Icon>&nbsp;Download Nota
//           </MDButton>
//         </MDBox>
//       </Grid>
//     </Grid>
//   );
//
//   useEffect(() => {
//     fetchPenjualan();
//   }, []);
//
//   // ================================================================
//   //                          UPDATE STATUS DELIVERY
//   // ================================================================
//   const updateDeliveryStatus = async (invoiceNumber, newStatus) => {
//     try {
//       const response = await axios.put(
//         `${BASE_URL}/delivery?id=${invoiceNumber}`,
//         { status: newStatus },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       Swal.fire("Berhasil", "Status pengiriman diperbarui!", "success");
//       fetchPenjualan();
//     } catch (error) {
//       console.error("Gagal update status pengiriman:", error);
//       Swal.fire("Gagal", "Status pengiriman gagal diperbarui", "error");
//     }
//   };
//
//   // ================================================================
//   //                            BAYAR PENJUALAN
//   // ================================================================
//
//   const handleOpenModal = (item) => {
//     setInvoicePayment(item.invoiceNumber);
//     const max = item.totalPrice - item.payment;
//     setMaxPayment(max);
//     setPayment(item.totalPrice);
//     setModalPaymentShow(true);
//   };
//
//   const handlePayment = async () => {
//     try {
//       const requestBody = {
//         payment: payment,
//       };
//
//       await axios.put(`${BASE_URL}/pay/debts?invoiceNumber=${invoicePayment}`, requestBody, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//
//       setModalPaymentShow(false);
//       Swal.fire("Berhasil", "Penjualan berhasil dibayarkan", "success");
//       fetchPenjualan();
//     } catch (error) {
//       setModalPaymentShow(false);
//       console.log(error);
//       Swal.fire("Gagal", "Penjualan gagal dibayarkan", "error");
//     }
//   };
//
//   const renderFormPayment = (
//     <Grid container spacing={2} maxWidth="lg">
//       <Grid item xs={12}>
//         <MDBox mb={2}>
//           <MDInput
//             fullWidth
//             size="xxl"
//             label="Bayar"
//             variant="outlined"
//             value={formatRupiah(payment)}
//             onChange={(e) => {
//               const val = e.target.value.replace(/[^0-9]/g, "");
//               if (parseInt(val || "0") <= maxPayment) {
//                 setPayment(val);
//               } else {
//                 setModalPaymentShow(false);
//                 Swal.fire("Peringatan", "Pembayaran melebihi hutang!", "warning");
//               }
//             }}
//             InputLabelProps={{ shrink: true }}
//           />
//         </MDBox>
//       </Grid>
//     </Grid>
//   );
//
//   const handleDateChange = (e) => {
//     const value = e.target.value;
//     setSelectedDate(value);
//     if (value) {
//       fetchPenjualan(value);
//     }
//   };
//
//   const inputDateSales = (
//     <MDInput
//       style={{ width: "100%" }}
//       type="date"
//       value={selectedDate}
//       onChange={handleDateChange}
//     />
//   );
//
//   // const sortedPenjualan = useMemo(() => {
//   //   if (!penjualan) return [];
//   //   return [...penjualan].sort((a, b) => new Date(a.date) - new Date(b.date));
//   // }, [penjualan]);
//   //
//   // const filteredPenjualan = useMemo(() => {
//   //   if (!filterSales) return sortedPenjualan;
//   //   return sortedPenjualan.filter(
//   //     (item) => (item.name || "").toLowerCase() === (filterSales.name || "").toLowerCase()
//   //   );
//   // }, [sortedPenjualan, filterSales]);
//
//   const sortedPenjualan = useMemo(() => {
//     if (!penjualan) return [];
//
//     // Fungsi bantuan untuk mengubah "DD-MM-YYYY" menjadi format yang bisa dibaca Date
//     const parseDate = (dateString) => {
//       const [day, month, year] = dateString.split("-");
//       return new Date(`${year}-${month}-${day}`);
//     };
//
//     return [...penjualan].sort((a, b) => parseDate(b.date) - parseDate(a.date));
//   }, [penjualan]);
//
//   const filteredPenjualan = useMemo(() => {
//     if (!filterSales) return sortedPenjualan;
//     return sortedPenjualan.filter(
//       (item) => (item.name || "").toLowerCase() === (filterSales.name || "").toLowerCase()
//     );
//   }, [sortedPenjualan, filterSales]);
//
//   const columnsSales = useMemo(
//     () => [
//       { Header: "No", accessor: "no", width: "1%", align: "left" },
//       { Header: "No Faktur", accessor: "no_faktur", align: "left" },
//       { Header: "Nama Restoran Pembeli", accessor: "nama_pembeli", align: "center" },
//       { Header: "Tanggal Pembelian", accessor: "tanggal_pembelian", align: "center" },
//       { Header: "Total Pembayaran", accessor: "total_pembayaran", align: "center" },
//       { Header: "Total Pembelian", accessor: "total_pembelian", align: "center" },
//       { Header: "Status Pembayaran", accessor: "status_pembayaran", align: "center" },
//       { Header: "Metode Pengiriman", accessor: "metode_pengiriman", align: "center" },
//       { Header: "Status Pengiriman", accessor: "status_pengiriman", align: "center" },
//       { Header: "action", accessor: "action", align: "center" },
//     ],
//     []
//   );
//
//   const rowsSales = useMemo(
//     () =>
//       filteredPenjualan.map((item, index) => ({
//         no: index + 1,
//         no_faktur: (
//           <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
//             {item.invoiceNumber || " - "}
//           </MDTypography>
//         ),
//         nama_pembeli: (
//           <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
//             {item.name || " - "}
//           </MDTypography>
//         ),
//         tanggal_pembelian: (
//           <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
//             {item.date || " - "}
//           </MDTypography>
//         ),
//         total_pembelian: (
//           <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
//             {formatRupiah(item.totalPrice) || " - "}
//           </MDTypography>
//         ),
//         total_pembayaran: (
//           <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
//             {formatRupiah(item.payment) || " - "}
//           </MDTypography>
//         ),
//         status_pembayaran: (
//           <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
//             {item.paymentStatus || " - "}
//           </MDTypography>
//         ),
//         metode_pengiriman: (
//           <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
//             {item.shippingMethod || " - "}
//           </MDTypography>
//         ),
//         status_pengiriman: (
//           <Autocomplete
//             disablePortal
//             options={["PENGIRIMAN", "GAGAL", "SELESAI"]}
//             value={item.deliveryStatus || ""}
//             onChange={(e, newValue) => updateDeliveryStatus(item.invoiceNumber, newValue)}
//             renderInput={(params) => (
//               <TextField {...params} variant="standard" size="small" sx={{ minWidth: 150 }} />
//             )}
//           />
//         ),
//         action: (
//           <MDBox display="flex" alignItems="center" mt={{ xs: 2, sm: 0 }} ml={{ xs: -1.5, sm: 0 }}>
//             <MDBox mr={1}>
//               <MDButton
//                 variant="text"
//                 color="error"
//                 onClick={() => {
//                   setModalDeleteShow(true);
//                   setInvoice(item.invoiceNumber);
//                 }}
//               >
//                 <Icon>delete</Icon>&nbsp;delete
//               </MDButton>
//             </MDBox>
//             <MDButton
//               variant="text"
//               color={darkMode ? "white" : "info"}
//               onClick={() => {
//                 handleDetailSales(item.invoiceNumber);
//               }}
//             >
//               <Icon>priority_high</Icon>&nbsp;detail
//             </MDButton>
//             <MDButton
//               variant="text"
//               color={darkMode ? "white" : "success"}
//               onClick={() => handleOpenModal(item)}
//               disabled={item.statusPayment === "LUNAS" || item.payment >= item.totalPrice}
//             >
//               <Icon>payment</Icon>&nbsp;bayar
//             </MDButton>
//             <MDButton
//               variant="text"
//               color="warning"
//               onClick={() => renderFormUpdate(item.invoiceNumber)}
//             >
//               <Icon>edit</Icon>&nbsp;edit
//             </MDButton>
//           </MDBox>
//         ),
//       })),
//     [filteredPenjualan, darkMode]
//   );
//
//   const modalDeleteSales = (
//     <MyModal
//       show={modalDeleteShow}
//       submitText="Hapus"
//       variant="danger"
//       onSubmit={handleDelete}
//       onHide={() => setModalDeleteShow(false)}
//       colorButtonSubmit="primary"
//       body="Apakah anda yakin ingin menghapus data ini?"
//     />
//   );
//
//   const modalDetailSales = (
//     <MyModal
//       show={modalDetailShow}
//       onHide={() => setModalDetailShow(false)}
//       title="Detail Penjualan"
//       body={renderFormDetailSales}
//     />
//   );
//
//   const modalPaymentSales = (
//     <MyModal
//       show={modalPaymentShow}
//       onHide={() => setModalPaymentShow(false)}
//       colorButtonSubmit="primary"
//       title="Pembayaran"
//       onSubmit={handlePayment}
//       body={renderFormPayment}
//     />
//   );
//
//   // Modal update sales — taruh bersama modal lainnya
//   const modalUpdateSales = (
//     <MyModal
//       show={modalUpdateSalesShow}
//       onHide={() => setModalUpdateSalesShow(false)}
//       title="Edit Penjualan"
//       body={renderFormUpdateSales}
//       onSubmit={handleUpdateSales}
//       submitText="Simpan Perubahan"
//       colorButtonSubmit="warning"
//     />
//   );
//
//   return {
//     columnsSales,
//     rowsSales,
//     inputDateSales,
//     snackbarComponentSales,
//     modalDeleteSales,
//     modalDetailSales,
//     modalPaymentSales,
//     modalUpdateSales,
//   };
// };
//
// export default data;

/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// @mui material components
import Icon from "@mui/material/Icon";
import { Snackbar, Grid, Typography, Autocomplete, TextField } from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useState, useEffect, useMemo } from "react";
import { useMaterialUIController } from "context";
import BASE_URL from "config/Base_URL";
import axios from "axios";
import MyModal from "components/Modal";
import Swal from "sweetalert2";
import MDTableCell from "@mui/material/TableCell";
import MDTableRow from "@mui/material/TableRow";
import MDTableBody from "@mui/material/TableBody";
import MDTable from "@mui/material/Table";
import { jsPDF } from "jspdf";

const data = ({ filterSales, setPenjualanParent, products = [] }) => {
  const token = sessionStorage.getItem("token");
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [modalDetailShow, setModalDetailShow] = useState(false);
  const [modalPaymentShow, setModalPaymentShow] = useState(false);
  const [modalUpdateSalesShow, setModalUpdateSalesShow] = useState(false);

  const [penjualan, setPenjualan] = useState([]);

  const [invoicePayment, setInvoicePayment] = useState("");
  const [payment, setPayment] = useState("");
  const [maxPayment, setMaxPayment] = useState(0);

  // State untuk DETAIL & NOTA (read-only)
  const [invoice, setInvoice] = useState("");
  const [username, setUsername] = useState("");
  const [dateSales, setDateSales] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [deliveryStatus, setDeliveryStatus] = useState("");
  const [shippingMethod, setShippingMethod] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [totalPaymentSales, setTotalPaymentSales] = useState("");
  const [paymentStatusSales, setPaymentStatusSales] = useState("");
  const [priceSales, setPriceSales] = useState("");
  const [noteSales, setNoteSales] = useState("");
  const [itemSales, setItemSales] = useState([]);
  const [noPembeli, setNoPembeli] = useState("");
  const [address, setAddress] = useState("");

  // ================================================================
  //         STATE KHUSUS FORM UPDATE (terpisah agar tidak konflik)
  // ================================================================
  const [updateInvoiceNumber, setUpdateInvoiceNumber] = useState("");
  const [updateBusinessName, setUpdateBusinessName] = useState("");
  const [updateDateSales, setUpdateDateSales] = useState("");
  const [updateDeliveryDate, setUpdateDeliveryDate] = useState("");
  // ✅ FIX: Nama state konsisten, satu nama saja
  const [updateDeliveryStatusSales, setUpdateDeliveryStatusSales] = useState("");
  const [updateTotalPayment, setUpdateTotalPayment] = useState("");
  const [updateNote, setUpdateNote] = useState("");
  const [updateSelectedProducts, setUpdateSelectedProducts] = useState([]);
  const [updateSelectedProduct, setUpdateSelectedProduct] = useState(null);
  const [updateCustomProduct, setUpdateCustomProduct] = useState({
    name: "",
    price: "",
    unit: "",
    quantity: 1,
  });

  const [selectedDate, setSelectedDate] = useState("");

  const statusOptions = ["SELESAI", "PENGIRIMAN", "GAGAL"];

  const vertical = "top";
  const horizontal = "right";

  const handleClose = () => setOpen(false);

  const snackbarComponentSales = (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      onClose={handleClose}
      message={message}
      key={vertical + horizontal}
      autoHideDuration={4000}
    />
  );

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(angka);
  };

  // ================================================================
  //                            GET PENJUALAN
  // ================================================================

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const fetchPenjualan = async (dateValue) => {
    const tanggal = dateValue || getTodayDate();
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios.get(`${BASE_URL}/sales?date=${tanggal}`, config);
      const responseData = response.data;
      if (responseData && responseData.data) {
        const dataArray = Array.isArray(responseData.data)
          ? responseData.data
          : [responseData.data];
        setPenjualan(dataArray);
        setPenjualanParent(dataArray);
      } else {
        setPenjualan([]);
        setPenjualanParent(responseData.data);
      }
      setMessage("Berhasil mengambil data Penjualan");
      setOpen(true);
    } catch (error) {
      console.error("Error:", error);
      setMessage("Tidak ada data penjualan di bulan ini");
      setOpen(true);
    }
  };

  // ================================================================
  //              FETCH DATA UNTUK EDIT SALES (buka modal update)
  // ================================================================
  const renderFormUpdate = async (numberInvoice) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/get/sales/update?invoiceNumber=${numberInvoice}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const d = response.data.data;
      setUpdateInvoiceNumber(numberInvoice);
      setUpdateBusinessName(d.businessName);
      setUpdateDateSales(d.date);
      setUpdateDeliveryDate(d.deliveryDate);
      setUpdateDeliveryStatusSales(d.deliveryStatus);
      setUpdateTotalPayment(d.totalPayment?.toString() || "0");
      setUpdateNote(d.note);

      const mappedItems = (d.items || []).map((item) => ({
        id: `item-${item.itemId}`,
        itemId: item.itemId,
        productId: item.productId,
        name: item.name,
        price: item.price,
        unit: item.unit,
        quantity: item.amount,
        subtotal: item.price * item.amount,
        disabled: item.disabled,
      }));

      setUpdateSelectedProducts(mappedItems);
      setModalUpdateSalesShow(true);
    } catch (error) {
      console.log(error);
      Swal.fire("Gagal", "Gagal mengambil data penjualan", "error");
    }
  };

  // ================================================================
  //          HELPER FUNCTIONS UNTUK FORM UPDATE
  // ================================================================

  const handleUpdateQuantityChange = (id, newQuantity) => {
    setUpdateSelectedProducts((prev) =>
      prev.map((p) =>
        p.id === id
          ? { ...p, quantity: newQuantity, subtotal: p.price * parseFloat(newQuantity || 0) }
          : p
      )
    );
  };

  const handleUpdateRemoveProduct = (id) => {
    setUpdateSelectedProducts((prev) =>
      prev
        .map((p) => {
          if (p.id !== id) return p;
          if (p.itemId !== null) {
            return { ...p, disabled: true };
          }
          return null;
        })
        .filter(Boolean)
    );
  };

  const handleUpdateAddProduct = () => {
    if (!updateSelectedProduct) return;

    const existingIndex = updateSelectedProducts.findIndex(
      (p) => p.productId === updateSelectedProduct.id
    );

    if (existingIndex >= 0) {
      setUpdateSelectedProducts((prev) =>
        prev.map((p, i) =>
          i === existingIndex
            ? {
                ...p,
                quantity: parseFloat(p.quantity || 0) + 1,
                subtotal: p.price * (parseFloat(p.quantity || 0) + 1),
              }
            : p
        )
      );
    } else {
      setUpdateSelectedProducts((prev) => [
        ...prev,
        {
          id: `new-${updateSelectedProduct.id}-${Date.now()}`,
          itemId: null,
          productId: updateSelectedProduct.id,
          name: `${updateSelectedProduct.name.toUpperCase()} - ${
            updateSelectedProduct.unit?.toUpperCase() || "KG"
          }`,
          price: updateSelectedProduct.price,
          unit: updateSelectedProduct.unit?.toUpperCase() || "KG",
          quantity: 1,
          subtotal: updateSelectedProduct.price,
        },
      ]);
    }
    setUpdateSelectedProduct(null);
  };

  const calculateUpdateTotal = () =>
    updateSelectedProducts
      .filter((p) => !p.disabled)
      .reduce((sum, p) => sum + (p.subtotal || 0), 0);

  // ================================================================
  //                    SUBMIT UPDATE SALES
  // ================================================================
  const handleUpdateSales = async () => {
    try {
      const salesItems = updateSelectedProducts.map((p) => ({
        itemId: p.itemId || 0,
        productId: p.productId || 0,
        name: p.name,
        price: p.price,
        unit: p.unit,
        amount: parseFloat(p.quantity) || 0,
        disabled: p.disabled ?? false,
      }));

      const requestBody = {
        businessName: updateBusinessName,
        date: updateDateSales,
        deliveryDate: updateDeliveryDate,
        deliveryStatus: updateDeliveryStatusSales,
        totalPayment: parseFloat(updateTotalPayment) || 0,
        note: updateNote || "-",
        items: salesItems,
      };

      await axios.put(
        `${BASE_URL}/update/sales/admin?invoiceNumber=${updateInvoiceNumber}`,
        requestBody,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setModalUpdateSalesShow(false);
      Swal.fire("Berhasil", "Penjualan berhasil diperbarui", "success");
      fetchPenjualan();
    } catch (error) {
      setModalUpdateSalesShow(false);
      console.log(error);
      Swal.fire("Gagal", "Penjualan gagal diperbarui", "error");
    }
  };

  // ================================================================
  //                  JSX FORM UPDATE SALES
  // ================================================================
  const renderFormUpdateSales = (
    <MDBox sx={{ width: "70vw" }}>
      {/* Nama Restoran (read-only, dari businessName API) */}
      <MDBox mb={2}>
        <MDInput
          fullWidth
          disabled
          label="Nama Restoran Pembeli"
          value={updateBusinessName}
          InputLabelProps={{ shrink: true }}
        />
      </MDBox>

      <MDBox mb={2}>
        <MDInput
          required
          type="date"
          label="Tanggal Penjualan"
          fullWidth
          value={updateDateSales}
          onChange={(e) => setUpdateDateSales(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </MDBox>

      <MDBox mb={2}>
        <MDInput
          required
          type="date"
          label="Tanggal Pengantaran"
          fullWidth
          value={updateDeliveryDate}
          onChange={(e) => setUpdateDeliveryDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </MDBox>

      <MDBox mb={2}>
        <Autocomplete
          disablePortal
          options={statusOptions}
          // ✅ FIX: pakai updateDeliveryStatus (nama state yang benar)
          value={updateDeliveryStatusSales}
          onChange={(_, newValue) => setUpdateDeliveryStatusSales(newValue)}
          fullWidth
          renderInput={(params) => <TextField {...params} label="Status Pengiriman" />}
        />
      </MDBox>

      <MDBox mb={2}>
        <MDInput
          type="text"
          label="Catatan"
          fullWidth
          value={updateNote}
          onChange={(e) => setUpdateNote(e.target.value)}
          multiline
          inputProps={{ maxLength: 250 }}
          rows={2}
          sx={{
            "& .MuiOutlinedInput-root": { alignItems: "flex-start" },
            "& textarea": { resize: "vertical", minHeight: "80px" },
          }}
        />
        <Typography variant="caption" color="textSecondary">
          Maksimal 250 karakter • {updateNote.length}/250
        </Typography>
      </MDBox>

      {/* Tambah produk dari katalog */}
      <MDBox mb={2} style={{ display: "flex", gap: "2%" }}>
        <Autocomplete
          // ✅ products di-pass dari Tables.jsx sebagai prop, tidak perlu fetch ulang
          options={products}
          getOptionLabel={(option) => `${option.name} - ${option.unit || ""}`}
          value={updateSelectedProduct}
          onChange={(_, newValue) => setUpdateSelectedProduct(newValue)}
          sx={{ width: "90%" }}
          renderInput={(params) => (
            <TextField {...params} label="Pilih Produk" variant="outlined" />
          )}
        />
        <MDButton
          variant="gradient"
          color="dark"
          onClick={handleUpdateAddProduct}
          disabled={!updateSelectedProduct}
          sx={{ height: "52px" }}
        >
          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
        </MDButton>
      </MDBox>

      {/* Produk custom / tidak ada di katalog */}
      <MDBox mb={2}>
        <MDTypography variant="h6">Produk Lainnya (Jika tidak tersedia di daftar)</MDTypography>
        <TextField
          label="Nama Produk"
          fullWidth
          sx={{ mb: 1 }}
          value={updateCustomProduct.name}
          onChange={(e) =>
            setUpdateCustomProduct({ ...updateCustomProduct, name: e.target.value.toUpperCase() })
          }
        />
        <TextField
          label="Harga Produk"
          fullWidth
          type="text"
          sx={{ mb: 1 }}
          value={formatRupiah(updateCustomProduct.price)}
          onChange={(e) => {
            const onlyNums = e.target.value.replace(/[^0-9]/g, "");
            setUpdateCustomProduct({ ...updateCustomProduct, price: onlyNums });
          }}
        />
        <TextField
          label="Unit"
          fullWidth
          sx={{ mb: 1 }}
          value={updateCustomProduct.unit}
          onChange={(e) =>
            setUpdateCustomProduct({ ...updateCustomProduct, unit: e.target.value.toUpperCase() })
          }
        />
        <TextField
          label="Jumlah"
          type="text"
          fullWidth
          sx={{ mb: 1 }}
          value={updateCustomProduct.quantity?.toString() ?? ""}
          onChange={(e) => {
            let value = e.target.value;
            if (/^\d*[.,]?\d{0,2}$/.test(value) || value === "") {
              value = value.replace(",", ".");
              setUpdateCustomProduct({ ...updateCustomProduct, quantity: value });
            }
          }}
          onBlur={(e) => {
            let value = e.target.value.replace(",", ".");
            let formatted = parseFloat(value);
            if (isNaN(formatted)) formatted = 0;
            formatted = parseFloat(formatted.toFixed(2));
            setUpdateCustomProduct({ ...updateCustomProduct, quantity: formatted });
          }}
        />
        <MDButton
          variant="outlined"
          color="info"
          fullWidth
          onClick={() => {
            if (updateCustomProduct.name && updateCustomProduct.price) {
              setUpdateSelectedProducts((prev) => [
                ...prev,
                {
                  id: `custom-${Date.now()}`,
                  itemId: null, // item baru
                  productId: 0, // 0 = produk custom
                  name: updateCustomProduct.name,
                  price: parseFloat(updateCustomProduct.price),
                  unit: updateCustomProduct.unit,
                  quantity: parseFloat(updateCustomProduct.quantity) || 1,
                  subtotal:
                    parseFloat(updateCustomProduct.price) *
                    (parseFloat(updateCustomProduct.quantity) || 1),
                },
              ]);
              setUpdateCustomProduct({ name: "", price: "", unit: "", quantity: 1 });
            } else {
              Swal.fire("Perhatian", "Silakan lengkapi Nama dan Harga produk lainnya", "warning");
            }
          }}
        >
          <Icon>add</Icon>&nbsp;Tambah Produk Lainnya
        </MDButton>
      </MDBox>

      {/* Tabel daftar produk yang akan di-update */}
      {updateSelectedProducts.length > 0 && (
        <MDBox mt={4}>
          <MDTypography variant="h6">Daftar Produk</MDTypography>
          <MDTable>
            <MDTableBody>
              {/* Header */}
              <MDTableRow>
                <MDTableCell sx={{ fontWeight: "bold", width: "30%" }}>Nama Produk</MDTableCell>
                <MDTableCell sx={{ fontWeight: "bold", textAlign: "right", width: "15%" }}>
                  Harga Satuan
                </MDTableCell>
                <MDTableCell sx={{ fontWeight: "bold", textAlign: "center", width: "10%" }}>
                  Unit
                </MDTableCell>
                <MDTableCell sx={{ fontWeight: "bold", textAlign: "center", width: "15%" }}>
                  Jumlah
                </MDTableCell>
                <MDTableCell sx={{ fontWeight: "bold", textAlign: "right", width: "20%" }}>
                  Subtotal
                </MDTableCell>
                <MDTableCell sx={{ fontWeight: "bold", textAlign: "center", width: "10%" }}>
                  Aksi
                </MDTableCell>
              </MDTableRow>

              {/*{updateSelectedProducts.map((product) => (*/}
              {updateSelectedProducts
                .filter((p) => !p.disabled)
                .map((product) => (
                  <MDTableRow key={product.id}>
                    <MDTableCell>{product.name}</MDTableCell>
                    <MDTableCell sx={{ textAlign: "right" }}>
                      Rp {product.price.toLocaleString()}
                    </MDTableCell>
                    <MDTableCell sx={{ textAlign: "center" }}>{product.unit}</MDTableCell>
                    <MDTableCell sx={{ textAlign: "center" }}>
                      <TextField
                        type="text"
                        sx={{
                          width: "80px",
                          "& .MuiInputBase-root": { height: "40px" },
                        }}
                        inputProps={{ inputMode: "decimal", style: { textAlign: "center" } }}
                        value={product.quantity?.toString() ?? ""}
                        onChange={(e) => {
                          let value = e.target.value;
                          if (/^\d*[.,]?\d{0,2}$/.test(value) || value === "") {
                            handleUpdateQuantityChange(product.id, value.replace(",", "."));
                          }
                        }}
                        onBlur={(e) => {
                          let value = e.target.value.replace(",", ".");
                          let formatted = parseFloat(value);
                          if (isNaN(formatted)) formatted = 0;
                          formatted = parseFloat(formatted.toFixed(2));
                          handleUpdateQuantityChange(product.id, formatted);
                        }}
                      />
                    </MDTableCell>
                    <MDTableCell sx={{ textAlign: "right" }}>
                      Rp {(product.subtotal || 0).toLocaleString()}
                    </MDTableCell>
                    <MDTableCell sx={{ textAlign: "center" }}>
                      {/* ✅ Klik hapus → langsung hilang dari tampilan (filter state lokal) */}
                      <MDButton
                        color="error"
                        onClick={() => handleUpdateRemoveProduct(product.id)}
                        sx={{ minWidth: "40px", width: "40px", height: "40px", padding: 0 }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>remove</Icon>
                      </MDButton>
                    </MDTableCell>
                  </MDTableRow>
                ))}

              {/* Baris total */}
              <MDTableRow>
                <MDTableCell colSpan={4} sx={{ textAlign: "right", fontWeight: "bold" }}>
                  Total:
                </MDTableCell>
                <MDTableCell sx={{ textAlign: "right", fontWeight: "bold" }}>
                  Rp {calculateUpdateTotal().toLocaleString()}
                </MDTableCell>
                <MDTableCell />
              </MDTableRow>
            </MDTableBody>
          </MDTable>
        </MDBox>
      )}

      <MDBox mb={2} mt={2}>
        <MDInput
          type="text"
          label="Total Pembayaran"
          fullWidth
          value={formatRupiah(updateTotalPayment)}
          onChange={(e) => {
            const onlyNums = e.target.value.replace(/[^0-9]/g, "");
            setUpdateTotalPayment(onlyNums);
          }}
        />
      </MDBox>
    </MDBox>
  );

  // ================================================================
  //                            DELETE PENJUALAN
  // ================================================================
  const handleDelete = async () => {
    try {
      await axios.delete(`${BASE_URL}/sales/delete?id=${invoice}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setModalDeleteShow(false);
      Swal.fire("Berhasil", "Penjualan berhasil dihapus", "success");
      fetchPenjualan();
    } catch (error) {
      setModalDeleteShow(false);
      console.log(error);
      Swal.fire("Gagal", "Penjualan gagal dihapus", "error");
    }
  };

  // ================================================================
  //                            DOWNLOAD NOTA
  // ================================================================
  const getDataNota = async (invoiceId) => {
    try {
      const response = await axios.get(`${BASE_URL}/nota/sales?id=${invoiceId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setNoPembeli(response.data.data.noHp);
      setAddress(response.data.data.address);
    } catch (error) {
      console.log(error);
    }
  };

  const downloadNota = () => {
    const tinggiPerBaris = 6;
    const tinggiHeader = 25;
    const jarakSetelahTabel = 4;
    const tinggiTotalSection = 21;
    const tinggiTandaTangan = 20;
    const tinggiFooter = 40;
    const marginBawah = 10;

    const tinggiTabel = itemSales.length * tinggiPerBaris;
    const tinggiKertas =
      tinggiHeader +
      tinggiTabel +
      jarakSetelahTabel +
      tinggiTotalSection +
      tinggiTandaTangan +
      tinggiFooter +
      marginBawah;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [297, tinggiKertas],
    });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("WENMART", 190, 20, { align: "center" });
    doc.text("NOTA PEMBELIAN BARANG", 190, 30, { align: "center" });

    doc.setFontSize(11);
    const marginAtas = 6;
    let y = 10 + marginAtas;
    doc.text(`No. Invoice: ${invoice}`, 10, y);
    y += 6;
    doc.text(`Tanggal: ${dateSales}`, 10, y);
    y += 6;
    doc.text(`Tanggal Pengiriman: ${deliveryDate}`, 10, y);
    y += 6;
    doc.text(`Nama Restoran Pembeli: ${username}`, 10, y);
    y += 6;
    doc.text(`Nomor Handphone: ${noPembeli}`, 10, y);
    y += 6;
    doc.text(`Alamat: ${address}`, 10, y);

    doc.setLineWidth(0.2);
    doc.line(10, y + 4, 287, y + 4);

    const startYTabel = y + 15;
    const tableWidth = 277;
    const tableHeight = tinggiTabel + 15;

    doc.rect(10, startYTabel, tableWidth, tableHeight);

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");

    const headerColumns = [
      { x: 10, width: 10, text: "No", align: "center" },
      { x: 20, width: 120, text: "Nama Produk", align: "left" },
      { x: 140, width: 20, text: "Qty", align: "center" },
      { x: 160, width: 20, text: "Unit", align: "center" },
      { x: 180, width: 40, text: "Harga", align: "right" },
      { x: 220, width: 67, text: "Subtotal", align: "right" },
    ];

    headerColumns.forEach((col) => {
      doc.text(col.text, col.x + col.width / 2, startYTabel + 4, { align: col.align });
    });

    doc.setFont("helvetica", "normal");
    itemSales.forEach((item, index) => {
      const rowY = startYTabel + 4 + (index + 1) * tinggiPerBaris;
      doc.text((index + 1).toString(), 15, rowY, { align: "center" });
      doc.text(item.name, 22, rowY, { maxWidth: 115, align: "left" });
      doc.text(item.amount.toString(), 150, rowY, { align: "center" });
      doc.text(item.unit, 170, rowY, { align: "center" });
      doc.text(formatRupiah(item.price).replace("Rp", "").trim(), 200, rowY, { align: "right" });
      doc.text(formatRupiah(item.total).replace("Rp", "").trim(), 285, rowY, { align: "right" });
    });

    let finalY = startYTabel + tableHeight + jarakSetelahTabel + 10;

    doc.setFontSize(11);
    doc.text("PENJUAL", 17, finalY);
    doc.text("Pembeli / Penerima Barang", 46, finalY);
    doc.text("Dicetak Oleh", 103, finalY);

    doc.setFontSize(14);
    doc.setFont("helvetica", "medium");
    doc.text("Total Pembelian:", 180, finalY);
    doc.text(formatRupiah(priceSales), 285, finalY, { align: "right" });
    finalY += 7;
    doc.text("Total Pembayaran:", 180, finalY);
    doc.text(formatRupiah(totalPaymentSales), 285, finalY, { align: "right" });
    finalY += 7;
    doc.text("Status:", 180, finalY);
    doc.text(paymentStatusSales, 285, finalY, { align: "right" });

    doc.setLineWidth(0.1);
    doc.rect(10, finalY - 18, 35, 20);
    doc.rect(45, finalY - 18, 55, 20);
    doc.rect(100, finalY - 18, 30, 20);
    doc.rect(175, finalY - 18, 112, 6);
    doc.rect(175, finalY - 12, 112, 6);
    doc.rect(175, finalY - 6, 112, 8);

    const footerY = tinggiKertas - marginBawah + 8;
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);
    doc.line(30, footerY - 10, 267, footerY - 10);
    doc.setFontSize(8);
    doc.setTextColor(80);
    doc.setFont("helvetica", "normal");
    doc.text("Terima kasih telah berbelanja di toko kami", 148.5, footerY - 4, {
      align: "center",
    });
    doc.text("Hubungi: 0812-3456-7890 | IG: @tjiangfuwen", 148.5, footerY, { align: "center" });

    doc.save(`nota_${invoice}.pdf`);
  };

  // ================================================================
  //                            DETAIL SALES
  // ================================================================
  const handleDetailSales = async (idSales) => {
    try {
      const response = await axios.get(`${BASE_URL}/sales/detail?id=${idSales}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const penjualanResponse = response.data.data;
      setInvoice(penjualanResponse.invoiceNumber);
      setUsername(penjualanResponse.businessName);
      setDateSales(penjualanResponse.date);
      setDeliveryDate(penjualanResponse.deliveryDate);
      setDeliveryStatus(penjualanResponse.deliveryStatus);
      setShippingAddress(penjualanResponse.shippingAddress);
      setShippingMethod(penjualanResponse.shippingMethod);
      setTotalPaymentSales(penjualanResponse.payment);
      setPriceSales(penjualanResponse.totalPrice);
      setPaymentStatusSales(penjualanResponse.paymentStatus);
      setNoteSales(penjualanResponse.note);
      setItemSales(penjualanResponse.items);

      setModalDetailShow(true);
    } catch (error) {
      console.log(error);
      Swal.fire("Gagal", "Gagal menampilkan detail penjualan!", "error");
    }
  };

  const renderFormDetailSales = (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <MDInput
          fullWidth
          disabled
          label="Invoice Number"
          variant="outlined"
          value={invoice}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MDInput
          fullWidth
          disabled
          label="Nama Restoran Pembeli"
          variant="outlined"
          value={username}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MDInput
          fullWidth
          disabled
          label="Tanggal Penjualan"
          variant="outlined"
          value={dateSales}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MDInput
          fullWidth
          disabled
          label="Tanggal Pengiriman"
          variant="outlined"
          value={deliveryDate}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MDInput
          fullWidth
          disabled
          label="Status Pengiriman"
          variant="outlined"
          value={deliveryStatus}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MDInput
          fullWidth
          disabled
          label="Total Penjualan"
          variant="outlined"
          value={formatRupiah(priceSales)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MDInput
          fullWidth
          disabled
          label="Total Pembayaran"
          variant="outlined"
          value={formatRupiah(totalPaymentSales)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MDInput
          fullWidth
          disabled
          label="Status"
          variant="outlined"
          value={paymentStatusSales}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <MDInput
          fullWidth
          disabled
          label="Metode Pengiriman"
          variant="outlined"
          value={shippingMethod}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12}>
        <MDInput
          fullWidth
          disabled
          label="Alamat Pengiriman"
          variant="outlined"
          value={shippingAddress}
          InputLabelProps={{ shrink: true }}
          multiline
          rows={2}
          sx={{
            "& .MuiOutlinedInput-root": { alignItems: "flex-start" },
            "& textarea": { resize: "vertical", minHeight: "50px" },
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <MDInput
          fullWidth
          disabled
          label="Catatan"
          variant="outlined"
          value={noteSales}
          InputLabelProps={{ shrink: true }}
          multiline
          rows={2}
          sx={{
            "& .MuiOutlinedInput-root": { alignItems: "flex-start" },
            "& textarea": { resize: "vertical", minHeight: "80px" },
          }}
        />
        <Typography variant="caption" color="textSecondary">
          Maksimal 250 karakter • {noteSales.length}/250
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <MDTable>
          <MDTableBody>
            <MDTableRow>
              <MDTableCell sx={{ fontWeight: "bold" }}>Nama Produk</MDTableCell>
              <MDTableCell sx={{ fontWeight: "bold", textAlign: "right" }}>
                Harga Satuan
              </MDTableCell>
              <MDTableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Unit</MDTableCell>
              <MDTableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Jumlah</MDTableCell>
              <MDTableCell sx={{ fontWeight: "bold", textAlign: "right" }}>Subtotal</MDTableCell>
            </MDTableRow>
            {itemSales.map((product) => (
              <MDTableRow key={product.id}>
                <MDTableCell>{product.name}</MDTableCell>
                <MDTableCell sx={{ textAlign: "right" }}>{formatRupiah(product.price)}</MDTableCell>
                <MDTableCell sx={{ textAlign: "center" }}>{product.unit}</MDTableCell>
                <MDTableCell sx={{ textAlign: "center" }}>{product.amount}</MDTableCell>
                <MDTableCell sx={{ textAlign: "right" }}>{formatRupiah(product.total)}</MDTableCell>
              </MDTableRow>
            ))}
            <MDTableRow>
              <MDTableCell colSpan={4} sx={{ textAlign: "right", fontWeight: "bold" }}>
                Total:
              </MDTableCell>
              <MDTableCell sx={{ textAlign: "right", fontWeight: "bold" }}>
                {formatRupiah(priceSales)}
              </MDTableCell>
            </MDTableRow>
          </MDTableBody>
        </MDTable>
      </Grid>
      <Grid item xs={12}>
        <MDBox display="flex" justifyContent="flex-end">
          <MDButton
            variant="gradient"
            color="info"
            onClick={() => {
              getDataNota(invoice);
              downloadNota();
            }}
          >
            <Icon>download</Icon>&nbsp;Download Nota
          </MDButton>
        </MDBox>
      </Grid>
    </Grid>
  );

  useEffect(() => {
    fetchPenjualan();
    // ✅ DIHAPUS: fetchProducts() — tidak perlu, products di-pass dari Tables.jsx
  }, []);

  // ================================================================
  //                    UPDATE STATUS DELIVERY (dropdown di tabel)
  // ================================================================
  const updateDeliveryStatus = async (invoiceNumber, newStatus) => {
    try {
      await axios.put(
        `${BASE_URL}/delivery?id=${invoiceNumber}`,
        { status: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      Swal.fire("Berhasil", "Status pengiriman diperbarui!", "success");
      fetchPenjualan();
    } catch (error) {
      console.error("Gagal update status pengiriman:", error);
      Swal.fire("Gagal", "Status pengiriman gagal diperbarui", "error");
    }
  };

  // ================================================================
  //                            BAYAR PENJUALAN
  // ================================================================
  const handleOpenModal = (item) => {
    setInvoicePayment(item.invoiceNumber);
    const max = item.totalPrice - item.payment;
    setMaxPayment(max);
    setPayment(item.totalPrice);
    setModalPaymentShow(true);
  };

  const handlePayment = async () => {
    try {
      await axios.put(
        `${BASE_URL}/pay/debts?invoiceNumber=${invoicePayment}`,
        { payment: payment },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setModalPaymentShow(false);
      Swal.fire("Berhasil", "Penjualan berhasil dibayarkan", "success");
      fetchPenjualan();
    } catch (error) {
      setModalPaymentShow(false);
      console.log(error);
      Swal.fire("Gagal", "Penjualan gagal dibayarkan", "error");
    }
  };

  const renderFormPayment = (
    <Grid container spacing={2} maxWidth="lg">
      <Grid item xs={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            size="xxl"
            label="Bayar"
            variant="outlined"
            value={formatRupiah(payment)}
            onChange={(e) => {
              const val = e.target.value.replace(/[^0-9]/g, "");
              if (parseInt(val || "0") <= maxPayment) {
                setPayment(val);
              } else {
                setModalPaymentShow(false);
                Swal.fire("Peringatan", "Pembayaran melebihi hutang!", "warning");
              }
            }}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>
    </Grid>
  );

  const handleDateChange = (e) => {
    const value = e.target.value;
    setSelectedDate(value);
    if (value) {
      fetchPenjualan(value);
    }
  };

  const inputDateSales = (
    <MDInput
      style={{ width: "100%" }}
      type="date"
      value={selectedDate}
      onChange={handleDateChange}
    />
  );

  const sortedPenjualan = useMemo(() => {
    if (!penjualan) return [];
    const parseDate = (dateString) => {
      if (!dateString) return new Date(0);
      const [day, month, year] = dateString.split("-");
      return new Date(`${year}-${month}-${day}`);
    };
    return [...penjualan].sort((a, b) => parseDate(b.date) - parseDate(a.date));
  }, [penjualan]);

  const filteredPenjualan = useMemo(() => {
    if (!filterSales) return sortedPenjualan;
    return sortedPenjualan.filter(
      (item) => (item.name || "").toLowerCase() === (filterSales.name || "").toLowerCase()
    );
  }, [sortedPenjualan, filterSales]);

  const columnsSales = useMemo(
    () => [
      { Header: "No", accessor: "no", width: "1%", align: "left" },
      { Header: "No Faktur", accessor: "no_faktur", align: "left" },
      { Header: "Nama Restoran Pembeli", accessor: "nama_pembeli", align: "center" },
      { Header: "Tanggal Pembelian", accessor: "tanggal_pembelian", align: "center" },
      { Header: "Total Pembayaran", accessor: "total_pembayaran", align: "center" },
      { Header: "Total Pembelian", accessor: "total_pembelian", align: "center" },
      { Header: "Status Pembayaran", accessor: "status_pembayaran", align: "center" },
      { Header: "Metode Pengiriman", accessor: "metode_pengiriman", align: "center" },
      { Header: "Status Pengiriman", accessor: "status_pengiriman", align: "center" },
      { Header: "action", accessor: "action", align: "center" },
    ],
    []
  );

  const rowsSales = useMemo(
    () =>
      filteredPenjualan.map((item, index) => ({
        no: index + 1,
        no_faktur: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.invoiceNumber || " - "}
          </MDTypography>
        ),
        nama_pembeli: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.name || " - "}
          </MDTypography>
        ),
        tanggal_pembelian: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.date || " - "}
          </MDTypography>
        ),
        total_pembelian: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {formatRupiah(item.totalPrice) || " - "}
          </MDTypography>
        ),
        total_pembayaran: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {formatRupiah(item.payment) || " - "}
          </MDTypography>
        ),
        status_pembayaran: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.paymentStatus || " - "}
          </MDTypography>
        ),
        metode_pengiriman: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.shippingMethod || " - "}
          </MDTypography>
        ),
        status_pengiriman: (
          <Autocomplete
            disablePortal
            options={["PENGIRIMAN", "GAGAL", "SELESAI"]}
            value={item.deliveryStatus || ""}
            onChange={(e, newValue) => updateDeliveryStatus(item.invoiceNumber, newValue)}
            renderInput={(params) => (
              <TextField {...params} variant="standard" size="small" sx={{ minWidth: 150 }} />
            )}
          />
        ),
        action: (
          <MDBox display="flex" alignItems="center" mt={{ xs: 2, sm: 0 }} ml={{ xs: -1.5, sm: 0 }}>
            <MDBox mr={1}>
              <MDButton
                variant="text"
                color="error"
                onClick={() => {
                  setModalDeleteShow(true);
                  setInvoice(item.invoiceNumber);
                }}
              >
                <Icon>delete</Icon>&nbsp;delete
              </MDButton>
            </MDBox>
            <MDButton
              variant="text"
              color={darkMode ? "white" : "info"}
              onClick={() => handleDetailSales(item.invoiceNumber)}
            >
              <Icon>priority_high</Icon>&nbsp;detail
            </MDButton>
            <MDButton
              variant="text"
              color={darkMode ? "white" : "success"}
              onClick={() => handleOpenModal(item)}
              disabled={item.statusPayment === "LUNAS" || item.payment >= item.totalPrice}
            >
              <Icon>payment</Icon>&nbsp;bayar
            </MDButton>
            {/* ✅ FIX: onClick arrow function yang benar, tidak ada syntax error tanda kurung */}
            <MDButton
              variant="text"
              color="warning"
              onClick={() => renderFormUpdate(item.invoiceNumber)}
            >
              <Icon>edit</Icon>&nbsp;edit
            </MDButton>
          </MDBox>
        ),
      })),
    [filteredPenjualan, darkMode]
  );

  const modalDeleteSales = (
    <MyModal
      show={modalDeleteShow}
      submitText="Hapus"
      variant="danger"
      onSubmit={handleDelete}
      onHide={() => setModalDeleteShow(false)}
      colorButtonSubmit="primary"
      body="Apakah anda yakin ingin menghapus data ini?"
    />
  );

  const modalDetailSales = (
    <MyModal
      show={modalDetailShow}
      onHide={() => setModalDetailShow(false)}
      title="Detail Penjualan"
      body={renderFormDetailSales}
    />
  );

  const modalPaymentSales = (
    <MyModal
      show={modalPaymentShow}
      onHide={() => setModalPaymentShow(false)}
      colorButtonSubmit="primary"
      title="Pembayaran"
      onSubmit={handlePayment}
      body={renderFormPayment}
    />
  );

  // ✅ Modal update sales — dikembalikan sebagai komponen JSX (bukan boolean)
  const modalUpdateSales = (
    <MyModal
      show={modalUpdateSalesShow}
      onHide={() => setModalUpdateSalesShow(false)}
      title="Edit Penjualan"
      body={renderFormUpdateSales}
      onSubmit={handleUpdateSales}
      submitText="Simpan Perubahan"
      colorButtonSubmit="warning"
    />
  );

  return {
    columnsSales,
    rowsSales,
    inputDateSales,
    snackbarComponentSales,
    modalDeleteSales,
    modalDetailSales,
    modalPaymentSales,
    // ✅ modalUpdateSales (komponen JSX) — bukan modalUpdateSalesShow (boolean)
    modalUpdateSales,
  };
};

export default data;
